import React from "react";
import { ReferralUser } from "@ecologi/shared";
import styled from "@emotion/styled";

const StyledLink = styled.a`
  border-bottom: 1px solid ${({ theme }) => theme.colors.night};
  color: ${({ theme }) => theme.colors.night};
  hyphens: auto;
  text-decoration: none;

  &:hover {
    border-bottom-color: ${({ theme }) => theme.colors.jungle};
    color: ${({ theme }) => theme.colors.jungle};
  }
`;

export const ReferralUserLink = ({
  referralUser,
}: {
  referralUser: ReferralUser;
}) => {
  const fullName =
    referralUser.firstName && referralUser.lastName
      ? `${referralUser.firstName} ${referralUser.lastName}`
      : null;
  const displayName =
    referralUser.groupName || fullName || referralUser.username;

  return (
    <StyledLink href={`/${referralUser.username}`} title="View profile">
      {displayName}
    </StyledLink>
  );
};
